
export default {
    getReport(authToken, {page, limit, filter, sort}) {
        let reportUrl = `https://panel-api.voluum.com/shared-report/report/${authToken}?`;

        if(filter && filter.length) {
            reportUrl += '&filter=' + filter;
        }

        if(sort) {
            reportUrl += `&sort=${sort.sortKey}&direction=${sort.sortDirection}`;
        }

        reportUrl += `&limit=${limit}`;
        reportUrl += `&offset=${(page - 1) * limit}`;



        const req = fetch(reportUrl, {
            cors: true,
            headers: {
                'Origin': window.location.origin
            }
        }).then(function(response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
            .then(data => data.json());

        return req;
    }
};



// WEBPACK FOOTER //
// ./src/services/ReportService.js